import { Product, Sale, Client } from "../types"

export const products: Product[] = [
  // {
  //   id: "1",
  //   type: "PHONE",
  //   name: "iPhone 13",
  //   identifier: "356789012345678",
  //   buyPrice: 350000,
  //   status: "IN_STOCK",
  // },
  // {
  //   id: "2",
  //   type: "COMPUTER",
  //   name: "Dell Latitude 5420",
  //   identifier: "DL-5420-9988",
  //   buyPrice: 420000,
  //   status: "SOLD",
  // },
]

export const sales = [
  // {
  //   id: "s1",
  //   productId: "356789012345678",
  //   phoneName: "iPhone 13",
  //   clientName: "Kouassi Jean",
  //   clientPhone: "0700000000",
  //   sellPrice: 450000,
  //   paid: 300000,
  //   remaining: 150000,
  //   soldAt: "06/01/2026 14:32",
  // },
]

export const clients: Client[] = [
  {
    id: "1",
    name: "Jean Kouassi",
    phone: "0700000000",
    balance: 200000,
  },
]

export const imeiIndex = [
  { imei: "356789012345678", model: "iPhone 13", status: "EN STOCK" },
  { imei: "490154203237518", model: "Samsung S22", status: "VENDU" },
]

export const suppliers = [
  "Samsung Distribution CI",
  "Apple Import Africa",
  "Techno Mobile",
  "Global Phones"
]

export const models = [
  {
    id: "m1",
    name: "iPhone 13",
    brand: "Apple",
    category: "PHONE",
    defaultBuyPrice: 350000,
    defaultSellPrice: 450000,
    createdAt: "2026-01-05",
  },
  {
    id: "m2",
    name: "Samsung Galaxy S22",
    brand: "Samsung",
    category: "PHONE",
    defaultBuyPrice: 300000,
    defaultSellPrice: 400000,
    createdAt: "2026-01-05",
  },
]

export const expenses = [
  {
    id: "e1",
    type: "Loyer",
    amount: 150000,
    description: "Loyer du mois de janvier",
    date: "05/01/2026",
  },
]

export const users = [
  {
    id: "u1",
    name: "Admin Principal",
    email: "admin@gestock.app",
    role: "ADMIN",
    active: true,
  },
  {
    id: "u2",
    name: "Vendeur 1",
    email: "vendeur@gestock.app",
    role: "VENDEUR",
    active: true,
  },
]

export const activityLogs = [
  {
    id: "a1",
    userName: "Admin Principal",
    role: "ADMIN",
    action: "AJOUT_TELEPHONE",
    description: "a ajouté un téléphone (iPhone 13 – IMEI 3569****)",
    date: "12/01/2026 10:15",
  },
  {
    id: "a2",
    userName: "Vendeur 1",
    role: "VENDEUR",
    action: "VENTE",
    description: "a effectué une vente (Samsung S22)",
    date: "12/01/2026 11:03",
  },
  {
    id: "a3",
    userName: "Vendeur 1",
    role: "VENDEUR",
    action: "PAIEMENT",
    description: "a encaissé un paiement de 50 000 FCFA",
    date: "12/01/2026 11:20",
  },
  {
    id: "a4",
    userName: "Admin Principal",
    role: "ADMIN",
    action: "AJOUT_DEPENSE",
    description: "a enregistré une dépense (Loyer)",
    date: "12/01/2026 12:00",
  },
  {
    id: "a5",
    userName: "Admin Principal",
    role: "ADMIN",
    action: "UTILISATEUR",
    description: "a créé un nouvel utilisateur (Vendeur 2)",
    date: "12/01/2026 12:30",
  },
]

// export const stores = [
//   {
//     id: "store_1",
//     name: "Boutique Abidjan - Plateau",
//   },
//   {
//     id: "store_2",
//     name: "Boutique Yopougon",
//   },
//   {
//     id: "store_3",
//     name: "Boutique Bouaké",
//   },
// ]


export const stores = [
  {
    id: "store_1",
    name: "Boutique Plateau",
    city: "Abidjan",
    isActive: true,
    createdAt: "2025-12-01",
  },
  {
    id: "store_2",
    name: "Boutique Yopougon",
    city: "Abidjan",
    isActive: true,
    createdAt: "2025-12-10",
  },
  {
    id: "store_3",
    name: "Boutique Bouaké",
    city: "Bouaké",
    isActive: false,
    createdAt: "2025-12-20",
  },
]

